import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Tutoring = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my tutoring business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps tutoring businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for tutoring businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most tutoring businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my tutoring business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like tutoring. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Tutoring - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Tutoring CRM", url: "/industries/tutoring" }
  ];

  const industryData = {
    name: 'Tutoring Service',
    title: 'Book More Sessions & Track Student Progress Effortlessly',
    subtitle: 'Automate session scheduling, send progress reports to parents, and build long-term tutoring relationships',
    icon: '📚',
    challenges: [
      'Scheduling conflicts with students',
      'Parents want constant progress updates',
      'One-time test prep doesn\'t continue',
      'Hard to manage multiple subjects/tutors',
      'Summer enrollment drops off'
    ],
    solutions: [
      'Online booking with student availability',
      'Automated progress report generation',
      'Long-term tutoring plan nurture',
      'Multi-tutor/subject management',
      'Summer program automation'
    ],
    features: [
      'Student CRM with grade tracking',
      'Online session booking',
      'Progress report automation',
      'Parent communication portal',
      'Multi-tutor scheduling',
      'Subject-specific resources',
      'Payment automation',
      'Review requests'
    ],
    results: [
      '80% continue beyond initial goal',
      'Book 60% more sessions',
      '90% parent satisfaction',
      '5.3K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Tutoring UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for tutoring businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for tutoring UK, tutoring business software, tutoring customer management, tutoring lead generation UK"
        url="/industries/tutoring"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Tutoring;